/**
 * Created by tofael on 3/21/17.
 */

import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';
import withWidth, {LARGE, SMALL} from 'material-ui/utils/withWidth';
import {connect as connectSocket, disconnect} from '../utility/socket-handler';
import api from '../utility/api';
import Layout from '../screens/layout';
import {setUser, destroyUser} from '../actions/user';
import {resetFeedbackBar, showFeedback} from '../actions/application';
import configuration from '../utility/app-config';
import {removeAuthUser, getUser, isUserAuthenticated, getToken}  from '../utility/local-storage';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      navDrawerOpen: true
    };
  }

  componentWillMount() {
    if (isUserAuthenticated()) {
      if (this.props.user.name === '') {
        this.props.dispatch(setUser(getUser()));
      }
    } else {
      hashHistory.push('/login');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.width !== nextProps.width) {
      this.setState({navDrawerOpen: nextProps.width === LARGE});
    }
  }

  componentDidMount() {
    connectSocket(getToken(), this.signOut);
  }

  toggleNavDrawer() {
    this.setState({navDrawerOpen: !this.state.navDrawerOpen});
  }

  dispatch(action) {
    this.props.dispatch(action());
  }

  closeFeedbackBar = () => {
    this.dispatch(resetFeedbackBar);
  };

  signOut = () => {
    api.logout()
      .then(()=> {
        disconnect();
        this.dispatch(destroyUser);
        removeAuthUser();
        hashHistory.push('login');
      })
      .catch((e)=>{
        this.props.dispatch(showFeedback({message: e.message}));
      });
  }

  render() {

    let {navDrawerOpen} = this.state;
    let {user, application, children} = this.props;
    let paddingLeftDrawerOpen = 236;
    let styles = {
      header: {
        paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0
      },
      container: {
        margin: '20px 20px 20px 15px',
        paddingLeft: navDrawerOpen && this.props.width !== SMALL ? paddingLeftDrawerOpen : 0
      }
    };

    let menus = configuration.menus.rmg;
    if (getUser() && (getUser().scheduler)) {
      menus = menus.concat(configuration.menus.common);
    }
    if (getUser() && (getUser().admin || getUser().operator)) {
      menus = menus.concat(configuration.menus.admin);
    }
    if (getUser() && getUser().super_admin) {
      menus = menus.concat(configuration.menus.super_admin);
    }

    let {notifyUser, notificationMessage} = this.props.application;

    return (
      <Layout
        id={user.id}
        menus={menus}
        styles={styles}
        children={children}
        username={user.name}
        notifyUser={notifyUser}
        drawerOpen={navDrawerOpen}
        signOut={this.signOut.bind(this)}
        isLoading={application.isLoading}
        notificationMessage={notificationMessage}
        toggleNavDrawer={this.toggleNavDrawer.bind(this)}
        closeFeedbackBar={this.closeFeedbackBar.bind(this)}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(withWidth()(App));



// WEBPACK FOOTER //
// ./src/containers/app.js